//import $ from 'jquery';

import { View } from 'backbone';
import template  from 'dashboard/reports/modal/confirm-report-delete-modal.ejs';
import restService      from 'RestService';
import restMessages      from 'RestMessages';
import NotificationService from 'NotificationService.js';
import ListService from 'ListService.js';
import eventBus  from 'EventBus.js';
import undoService from 'UndoService.js'
import constants        from 'Constants.js';
import textConstants from 'TextConstants';
import ReportLeftPanelView from 'dashboard/reports/ReportLeftPanelView';

class ConfirmReportDeleteModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#confirmDeleteModal";

        this.setModalTitle();
        this.model.set('confirmDelete', '');

        return this;
    }

    setModalTitle() {
        const mode = this.model.get('mode');
        let deleteTitle = '';
        switch (mode) {
            case 'deleteReport':
                deleteTitle = 'Delete Report';
                break;
            case 'deletePrevious':
                deleteTitle = 'Delete Previous Versions';
                break;
        }
        this.model.set('deleteTitle', deleteTitle);
    }

    displayModalTexts() {
        const mode = this.model.get('mode');
        let text1, text2;
        switch (mode) {
            case 'deleteReport':
                text1 = 'Are you sure you want to delete this report, including all previous versions?';
                text2 = "This deletion can be reversed by clicking the 'Undo' icon. However, it can no longer be reversed after you have logged out.";
                $('button.btn-select-field').button("enable");
                $('#confirmPanel').hide();
                break;
            case 'deletePrevious':
                text1 = 'Are you sure you want to delete all previous versions and instances of this report?';
                text2 = 'This action cannot be reversed!';
                $('#confirmPanel').show();
                break;
        }
        $('#text1').html(text1);
        $('#text2').html(text2);
    }


    confirmDelete() {
        let result = '';
        const mode = this.model.get('mode');
        switch (mode) {
            case 'deleteReport':
                result = this.deleteReport().then(()=>{
                    undoService.add({
                        redo: () => {
                            this.deleteReport();
                        },
                        undo: () => {
                            this.unDeleteReport();
                        }
                    },textConstants.UNDO_DELETE_REPORT)
                });
                break;
            case 'deletePrevious':
               result=this.resetReport();
                break;
        }
        return result;
    }

    deleteReport() {
        const reportId = this.model.get('reportId');
        return restService.deleteReport(reportId).then((data) => {
            if(ListService.activeDashboardTab === 'reports') {
                eventBus.trigger('loadReportsView');
            }
            else{
                NotificationService.success(`${this.model.get('reportName')} was deleted. Clicking undo restores it.`);
            }
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    unDeleteReport(){

        const reportId = this.model.get('reportId');
        const groupId = this.model.get('GroupId');
        const groupType = this.model.get('groupType');

        return restService.unDeleteReport(reportId).then(data => {

            let dataTarget=data.GroupId ? `#well${data.GroupId}` : constants.EDIT_FORMS_CONTAINER;
            if(ListService.activeDashboardTab === 'reports') {
                eventBus.trigger(constants.EV_UNDELETE_REPORT, {
                    msg: `Report "${data.Name}" restored`,
                    reportId,
                    name: data.Name,
                    nodeTarget: dataTarget,
                    groupTypeId: data.GroupTypeId,
                    parentId: data.GroupId
                },reportId, groupType, groupId, dataTarget);
            }
            else{
                NotificationService.success(`${this.model.get('reportName')} was restored.`);
            }
            return data;
        }, error => {
            return error;
        });

    }

    resetReport() {
        const reportId = this.model.get('reportId');
        restService.resetReport(reportId).then((data) => {
            eventBus.trigger('resettingReport', reportId);
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    getConfirmText(e){
        let word = e.currentTarget.value;
        if (word.toLowerCase() === 'confirm'){
            $('button.btn-select-field').button("enable");
        } else {
            $('button.btn-select-field').button("disable");
        }
    }

    bindEvents() {
        $("#confirmDelete").keyup((e)=>{
            this.getConfirmText(e);
        });
    }

    unbindEvents() {
        $("#confirmDelete").unbind();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {

        let confirmDelete = $('#confirmDeleteModal');
        if (confirmDelete) {
            confirmDelete.remove();
        }

        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            let self = this;
            let height = 280;
            if (self.model.get('mode') !== 'deleteReport'){
                height = 330;
            }

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: height,
                width: 450,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            self.unbindEvents();
                            this.dialog.dialog( "close" );
                            resolve(self.confirmDelete());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            reject('cancel');
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                    self.bindEvents();
                    self.displayModalTexts()
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default ConfirmReportDeleteModal;
